import { ActionPointInfo, Controller, IActionPointInfo, Menu } from '@tencent/workbench';
import { ImagesJointFeature } from './images-joint-feature';
import { config, IMAGES_JOINT_MENU_CONFIGS } from './config';

@Controller({
    menuItems: IMAGES_JOINT_MENU_CONFIGS,
})
export class ImagesJointController {
    public constructor(private readonly feature: ImagesJointFeature) {
    }

    @Menu(config.id, 'onClick')
    public onClick(@ActionPointInfo() info:  IActionPointInfo) {
        this.feature.showImagesJoint(info);
    }
}
